// @ts-nocheck

angular.module('yaltyApp')
    .controller('loyaltyCardRegistrationDonPepeCtrl', function ($scope, $timeout, $rootScope, $http, $state, $location, API_PREFIX, AuthService, $mdDialog, GoogleAnalyticsService, $cookies, $window, $filter) {
        if ($state.params.lang != null) {
            $scope.lang = $state.params.lang;
        }
        $scope.addrCountry = 1;

        $scope.datePickerOpen = false;
        $scope.preventInput = function (event) {
            event.preventDefault();
        }
        $scope.openCalendarView = function () {
            $scope.datePickerOpen = true;
        }

        if (window.i18next) {
            window.i18next.use(window.i18nextXHRBackend);
            window.i18next.init({
                debug: false,
                lng: $scope.lang,
                fallbackLng: 'hu',
                backend: {
                    loadPath: '/api/translations/web_app_translation_{{lng}}.json'
                }
            }, function (err, t) {
                $scope.title = i18next.t('services.loyalty_card_registration.don_pepe.name');
                $scope.emailText = i18next.t('form.email.label');
                $scope.email_invalid_text = i18next.t('form.email.invalid');
                $scope.firstNameText = i18next.t('form.user.firstName');
                $scope.lastNameText = i18next.t('form.user.lastName');
                $scope.phone_number_text = i18next.t('form.phoneNumber.label');
                $scope.phone_number_invalid_text = i18next.t('form.phoneNumber.invalid');
                $scope.ok_text = i18next.t('generic.ok');
                $scope.server_error = i18next.t('generic.server_error');
                $scope.general_terms_and_conditions1 = i18next.t('form.general_terms_and_conditions.text_part1');
                $scope.general_terms_and_conditions2 = i18next.t('form.general_terms_and_conditions.text_part2');
                $scope.general_terms_and_conditions3 = i18next.t('form.general_terms_and_conditions.text_part3');
                $scope.required = i18next.t('generic.required');
                $scope.country = i18next.t('form.address.country');
                $scope.country_hungary = i18next.t('form.address.country_hungary');
                $scope.zip_code = i18next.t('form.address.zip_code');
                $scope.minimum_zip_code = i18next.t('form.address.minimum_zip_code');
                $scope.maximum_zip_code = i18next.t('form.address.maximum_zip_code');
                $scope.city = i18next.t('form.address.city');
                $scope.street = i18next.t('form.address.street');
                $scope.house_number = i18next.t('form.address.house_number');
                $scope.birth_date_text = i18next.t('form.user.birth_date');
                $scope.date_of_birth_format_error = i18next.t('form.user.date_of_birth_format_error');
                $scope.max_character_error_first_part = i18next.t('generic.max_character_error_first_part');
                $scope.character_lenght_error_last_part = i18next.t('generic.character_lenght_error_last_part');
                if ($state.params.insid != null) {
                    $scope.button = i18next.t('form.modify_data.button');
                } else {
                    $scope.button = i18next.t('form.registration.button');
                    $scope.registrationMissingTermsAndConditions = i18next.t('form.registration.missing_terms_and_conditions');
                }
                $scope.$apply();
            })
        }
        $scope.insid = $state.params.insid;
        $scope.firstName = $state.params.fname;
        $scope.lastName = $state.params.lname;
        $scope.email = $state.params.email;
        $scope.token = $state.params.token;
        $scope.dateOfBirth = $state.params.birthday;
        if ($state.params.insid != null) {
            $scope.instanceId = $state.params.insid;
            $scope.loadingInProgress = true;
            let data = {
                token: $scope.token,
                loyaltyCardInstanceId: $state.params.insid
            };
            $http.post(API_PREFIX.url + '/loyaltyCard/getLoyaltyCardInstanceRegistrationData', data).then(function (result) {
                $scope.loadingInProgress = false;
                if (result.data.errorCode == 0) {
                    $scope.customerLoyaltyId = result.data.customerLoyaltyId;
                    $scope.lastName = result.data.lastName;
                    $scope.firstName = result.data.firstName;
                    $scope.email = result.data.emailAddress;
                    $scope.phoneNumber = result.data.phoneNumber;
                    $scope.addrCountry = result.data.addrCountry;
                    $scope.addrZIP = result.data.addrZIP;
                    $scope.addrCity = result.data.addrCity;
                    $scope.addrStreet = result.data.addrStreet;
                    $scope.addrNumber = result.data.addrNumber;
                    $scope.dateOfBirth = result.data.dateOfBirth;
                }
                else {
                    setTimeout(function () {
                        location.href = "service/loyaltyCardRegistrationDataLoadingUnsuccessful";
                    }, 100);
                }
            }, function () {
                $scope.loadingInProgress = false;
                location.href = "service/loyaltyCardRegistrationDataLoadingUnsuccessful";
            });
        }

        $scope.registration = function () {
            $scope.registrationInProgress = true;
            if (checkFormForErrors()) {
                $scope.registrationInProgress = false;
            } else {
                const host = $location.host();
                let data = {};
                if ($state.params.insid != null) {
                    data = {
                        loyaltyCardInstanceId: $state.params.insid,
                        token: $scope.token,
                        //companyId: 512,
                        loyaltyCardId: (host == 'localhost' ||
                            host == 'yalty-appserv-dev-development-002.azurewebsites.net') ? 84 : 110,
                        customerLoyaltyId: $scope.customerLoyaltyId,
                        registrationData: {
                            lastName: $scope.lastName,
                            firstName: $scope.firstName,
                            emailAddress: $scope.email,
                            phoneNumber: $scope.phoneNumber,
                            addrCountry: $scope.addrCountry,
                            addrZIP: $scope.addrZIP,
                            addrCity: $scope.addrCity,
                            addrStreet: $scope.addrStreet,
                            addrNumber: $scope.addrNumber,
                            dateOfBirth: $scope.dateOfBirth
                        }
                    };
                } else {
                    data = {
                        token: $scope.token,
                        loyaltyCardId: (host == 'localhost' ||
                            host == 'yalty-appserv-dev-development-002.azurewebsites.net') ? 84 : 110,
                        registrationData: {
                            lastName: $scope.lastName,
                            firstName: $scope.firstName,
                            emailAddress: $scope.email,
                            phoneNumber: $scope.phoneNumber,
                            addrCountry: $scope.addrCountry,
                            addrZIP: $scope.addrZIP,
                            addrCity: $scope.addrCity,
                            addrStreet: $scope.addrStreet,
                            addrNumber: $scope.addrNumber,
                            dateOfBirth: $scope.dateOfBirth
                        }
                    };
                }
                $http.post(API_PREFIX.url + '/loyaltyCard/addOrUpdateLoyaltyCardInstance_v3', data).then(function (result) {
                    $scope.registrationInProgress = false;
                    if (result.data.errorCode == 0) {
                        if ($state.params.insid != null) { location.href = "service/loyaltyCardRegistrationDataModifiedSuccessful"; }
                        else location.href = "service/loyaltyCardRegistrationSuccessful?id=" + result.data.registeredLoyaltyCardInstanceId;
                    } else {
                        if ($state.params.insid != null) {
                            location.href = "service/loyaltyCardRegistrationDataModifiedUnsuccessful";
                        } else {
                            location.href = "service/loyaltyCardRegistrationUnsuccessful";
                        }
                    }
                }, function () {
                    $scope.registrationInProgress = false;
                    if ($state.params.insid != null) {
                        location.href = "service/loyaltyCardRegistrationDataModifiedUnsuccessful";
                    } else {
                        location.href = "service/loyaltyCardRegistrationUnsuccessful";
                    }
                });
            }
        }

        function checkFormForErrors() {
            if ($state.params.insid == null) {
                if (!$scope.registrationForm.$valid) {
                    if ($scope.registrationForm.email.$invalid) {
                        $scope.registrationForm.email.$setTouched();
                        const element = document.getElementById("email")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.lastName.$error.required) {
                        $scope.registrationForm.lastName.$setTouched();
                        const element = document.getElementById("lastName")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.firstName.$error.required) {
                        $scope.registrationForm.firstName.$setTouched();
                        const element = document.getElementById("firstName")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.phoneNumber.$invalid) {
                        $scope.registrationForm.phoneNumber.$setTouched();
                        const element = document.getElementById("phoneNumber")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.addrZIP.$invalid) {
                        $scope.registrationForm.addrZIP.$setTouched();
                        const element = document.getElementById("addrZIP")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.addrCity.$invalid) {
                        $scope.registrationForm.addrCity.$setTouched();
                        const element = document.getElementById("addrCity")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.addrStreet.$invalid) {
                        $scope.registrationForm.addrStreet.$setTouched();
                        const element = document.getElementById("addrStreet")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.addrNumber.$invalid) {
                        $scope.registrationForm.addrNumber.$setTouched();
                        const element = document.getElementById("addrNumber")
                        element.scrollIntoView();
                        return true;
                    } else if ($scope.registrationForm.dateOfBirth.$invalid) {
                        $scope.registrationForm.dateOfBirth.$setTouched();
                        const element = document.getElementById("dateOfBirth")
                        element.scrollIntoView();
                        return true;
                    }
                }

                if ($scope.acceptedGeneralConditions != true) {
                    const alert = $mdDialog.alert()
                        .title("")
                        .textContent($scope.registrationMissingTermsAndConditions)
                        .ok($scope.ok_text)
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                    $mdDialog.show(alert);
                    return true;
                }
            } else {
                return false;
            }

        }
    })